import { Factory, trait } from 'miragejs';

export default Factory.extend({
  actionType: 'alert',

  // Traits
  withEmployee: trait({
    afterCreate(contact, server) {
      const employee = server.create('employee');
      contact.employee = employee;
    },
  }),
});
